import React from "react";
import { Routes, Route } from "react-router-dom";
import RequireAuth from "./Analysis/pages/RequireAuth";
import Homepage from "./Home/Pages/Homepage";
import Login from "./Home/Pages/Login";
import ResetPassword from "./Home/Pages/ResetPassword";
import PageNotFound from "./Home/Pages/PageNotFound";
import HomeDashboard from "./Analysis/pages/HomeDashboard";
import Hybrid from "./Analysis/pages/Hybrid";
import GlobalStyles from "./GlobalStyles";
import "./ToggleSideBar.css";

function App() {
  return (
    <div className="App">
      <GlobalStyles />
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/login" element={<Login />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="*" element={<PageNotFound />} />

        {/* protected routes */}
        <Route element={<RequireAuth />}>
          <Route path="/home" element={<HomeDashboard />} />
          <Route path="/dashboard/:subject" element={<Hybrid />} />
        </Route>
      </Routes>
    </div>
  );
}

export default App;
